import React, { useState, useEffect } from "react";
import "./Style/navbar.css";
import Streak from "./data/Streak.json";
import green from "./data/green.json";
import Lottie from "react-lottie";
export default function NavBar(props) {
  const [state, setState] = useState(null);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Streak,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: green,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="navbar">
      {/* <img src="/images/Menu.png" alt="Menu" className="icon" /> */}
      <div className="logodiv">
        <img src="/Favicon-Grini.ico" alt="logo" className="logo" />
        <p>Grini</p>
      </div>
      <button id="install-button" className="install">
        <span>Download</span>{" "}
        {/* <span>
          <Icon icon="material-symbols:install-desktop" className={"icon-i"} />
        </span> */}
      </button>
      <div className="streak">
        <Lottie options={defaultOptions} height={50} width={50} />
        {/* <Lottie options={defaultOptions1} height={35} width={35} /> */}
        {/* <img src="/images/Streak.png" alt="streak" className="icon" /> */}
        <span>25</span>
      </div>
    </div>
  );
}
